<template>
  <fieldset>
    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <div class="input-group-text">Personal Access Token</div>
      </div>
      <input type="text" class="form-control" required v-model="personalAccessToken" @input="onUpdate">
    </div>
    <p class="small mb-3">
      För att hämta er din Personal Access Token, se  <a href="https://developer.calendly.com/how-to-authenticate-with-personal-access-tokens">instruktioner från Calendly</a>
    </p>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const personalAccessToken = ref(null);
const serializedValue = computed(() => {
  return {
    personal_access_token: personalAccessToken.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    personalAccessToken.value = modelValue.value.personal_access_token;
  }
}, {
  immediate: true
});
</script>
